/* istanbul ignore file */
import { panelDecorator } from '@bingads-webui-campaign-react/panel-decorator';
import Backbone from 'backbone';
import _ from 'underscore';
import { InlineLocationRecommendation } from './view';

export class InlineLocationRecommendationPanel extends Backbone.View {
  initialize(options) {
    this.options = options;
    this.deps = options.deps;
    this.isRecommendationOperated = false;
    this.locationAdded = false;
    this.recommendations = [];
  }

  render() {
    const View = panelDecorator(InlineLocationRecommendation, {
      i18n: this.deps.i18n,
      panelReadyAriaLabel: this.deps.i18n.getString('Inline location recommendation side panel opened'),
    });
    const viewOptions = {
      title: this.deps.i18n.getString('Inline_Location_Recommendation_Dialog_Title'),
      // these events should keep consistance with dialog events
      // this part is difficult to test since the inside instance is difficult to get from outside
      // ignore this for the component and will add end to end test in feature scenarios.
      eventsToActions: [{
        event: 'cancel',
        action: this.remove.bind(this),
      }, {
        event: 'add:locations',
        action: () => { this.locationAdded = true; },
      }, {
        event: 'operate:recommendations',
        action: () => { this.isRecommendationOperated = true; },
      }, {
        event: 'remove',
        action: () => {
          if (this.locationAdded) { // refresh when add locations
            this.trigger('refresh:recommendations');
          } else if (_.isEmpty(this.recommendations) && this.isRecommendationOperated) {
            this.trigger('refresh:recommendations');
          }
        },
      }, {
        event: 'update:recommendations',
        action: (recommendations) => {
          this.recommendations = recommendations;
          if (_.size(recommendations) === 0) { // if no recommendations, remove dialog
            this.remove();
          }
        },
      }],
      onClose: this.remove.bind(this),
      template: 'inlineTemplate',
      isCampaignLevelLocation: true,
      showRecommendationsOnMap: true,
      isExpanded: true,
      ...this.options,
    };
    this.view = new View(viewOptions).render();
    return this;
  }

  remove() {
    if (this.view) {
      this.view.remove();
    }
    super.remove();
  }
}
